import cssIf from "../../../scripts/helpers/class.add.if";
import "./options.scss";

const Options = ({ show, close, list, top = 35 }) => (

  <div className={`options ${ cssIf( show, "opened" )}`} style = {{ top: `${ top }px`}}>

    { list.map(( el, key ) => (
      
      <div
        key = { key }
        id = { el?.id || "" }
        onClick = { () => { el.action(); close(); }}
        className = "options__element"
        style = {{
          color: el?.color ? el.color : undefined
        }}
      >
        
        { el?.text ? el.text : el }

      </div>
      
    ))}

  </div>

);

export default Options;